import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';
import { googleAnalytics } from '../Services/googleAnalytics';
import { translate } from '../Services/translation';

const BuyButton = ({
  label,
  articleNumber,
  quantityFieldId,
  href,
  cssClass,
  onClick,
}) => {
  return (
    <Fragment>
      {articleNumber ? (
        <Fragment>
          {href ? (
            <a
              className={cssClass}
              onClick={(e) => {
                e.preventDefault();
                onClick({ articleNumber, quantityFieldId });
              }}
              href={href}
              rel="nofollow"
              aria-label={label}
            >
              {label}
            </a>
          ) : (
            <button
              type="button"
              className={cssClass}
              onClick={(e) => {
                e.preventDefault();
                onClick({ articleNumber, quantityFieldId });
              }}
              aria-label={label != undefined || "" ? label : translate('button.addtocart')}
            >
              {label}
            </button>
          )}
        </Fragment>
      ) : (
        <a className={cssClass} href={href || '#'} rel="nofollow" aria-label={label}>
          {label}
        </a>
      )}
    </Fragment>
  );
};

const StyledButton = (props) => {
  const dispatch = useDispatch();
  const onClick = async ({ articleNumber, quantityFieldId }) => {
    try {
      const minValue = props.minValue;
      const quantity = quantityFieldId
        ? document.getElementById(quantityFieldId).value
        : minValue == undefined
        ? 1
        : minValue;
      const cart = await addToCartService({ articleNumber, quantity });
      googleAnalytics({
        event: 'addToCart',
        ecommerce: cart.gaCartViewModel,
      });
      dispatch(receive(cart));
      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };
  const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
  return <Button {...props} />;
};

export default StyledButton;
